import React from 'react';

interface CSVDownloadProps {
  data: any;
  filename: string;
}

export class CSVDownload extends React.Component<CSVDownloadProps> {
  render() {
    const { children, ...props } = this.props;
    const elem: any = React.Children.only(children);

    return React.cloneElement(elem, { ...props, onClick: this.onClick });
  }

  private readonly onClick = (event: any) => {
    const { data, filename, children } = this.props;

    const type = this.isSafari() ? 'application/csv' : 'text/csv';
    const blob = new Blob([data], { type });
    const dataURI = `data:${type};charset=utf-8,${data}`;

    const URL = window.URL;

    const result: any = typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);

    const downloadLink: any = document.createElement('a');
    downloadLink.href = result;
    downloadLink.download = `${filename}.csv`;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    const elem: any = React.Children.only(children);

    // Bypass onClick if it was present
    if (elem && elem.props && typeof elem.props.onClick === 'function') {
      elem.props.onClick(event);
    }
  };

  private readonly isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
